import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';

import ManifestationListItemContainer from '../ManifestationListItem/ManifestationListItemContainer';
import './ManifestationList.scss';

export class ManifestationList extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderListings() {
    const { itemPosition, manifestations, reciprocalRank } = this.props;
    const singleItem = manifestations.count() === 1;
    const totalCount = manifestations.count();

    return manifestations.map((item, index) => (
      <ManifestationListItemContainer
        item={item}
        key={item.get('id')}
        drawerOpen={singleItem}
        reciprocalRank={reciprocalRank}
        itemPosition={itemPosition}
        itemPositionGrouped={index + 1}
        totalCount={totalCount}
      />
    ));
  }

  render() {
    return <div className="cp-manifestation-list">{this.renderListings()}</div>;
  }
}

ManifestationList.propTypes = {
  itemPosition: PropTypes.number,
  manifestations: ImmutablePropTypes.listOf(bibShape),
  reciprocalRank: PropTypes.number
};

ManifestationList.defaultProps = {
  manifestations: Immutable.List()
};

export default ManifestationList;
